(function () {
  'use strict';

  // Guard against this ever running twice (e.g. if it does end up inlined
  // in a template that gets rendered more than once during a session).
  if (window.__mcuInit) return;
  window.__mcuInit = true;

  function closestWrap(el) {
    return el.closest('[data-mcu]');
  }

  function getParts(wrap) {
    var track = wrap.querySelector('[data-mcu-track]');
    var items = track ? Array.prototype.slice.call(track.children) : [];
    var dotsWrap = wrap.querySelector('[data-mcu-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];
    return { track: track, items: items, dots: dots };
  }

  function currentIndex(track, items) {
    var trackRect = track.getBoundingClientRect();
    var closestIdx = 0;
    var closestDist = Infinity;
    items.forEach(function (item, i) {
      var dist = Math.abs(item.getBoundingClientRect().left - trackRect.left);
      if (dist < closestDist) { closestDist = dist; closestIdx = i; }
    });
    return closestIdx;
  }

  function goTo(items, index) {
    if (!items.length) return;
    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;
    items[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
  }

  /* ------------------------------------------------------------------
     Carousel: arrows + dots, fully delegated to document. Nothing here
     needs to be "bound" to a specific mcu-wrap instance, so this works
     no matter how many times the surrounding drawer markup gets replaced.
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-mcu-prev]');
    var next = e.target.closest('[data-mcu-next]');
    var dot = e.target.closest('[data-mcu-dot-index]');
    if (!prev && !next && !dot) return;

    var wrap = closestWrap(e.target);
    if (!wrap) return;
    var parts = getParts(wrap);
    if (!parts.track) return;

    if (prev) {
      goTo(parts.items, currentIndex(parts.track, parts.items) - 1);
    } else if (next) {
      goTo(parts.items, currentIndex(parts.track, parts.items) + 1);
    } else if (dot) {
      goTo(parts.items, parseInt(dot.getAttribute('data-mcu-dot-index'), 10));
    }
  });

  // scroll doesn't bubble, so listen in the capture phase to catch it
  // from any [data-mcu-track] currently on the page.
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.matches || !track.matches('[data-mcu-track]')) return;
    var wrap = closestWrap(track);
    if (!wrap) return;
    var parts = getParts(wrap);
    var idx = currentIndex(parts.track, parts.items);
    parts.dots.forEach(function (d, i) { d.classList.toggle('is-selected', i === idx); });
  }, true);

  /* ------------------------------------------------------------------
     Add to cart -- unchanged, already delegated to document.
  ------------------------------------------------------------------ */
  function refreshDawnCart() {
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var parser = new DOMParser();

        if (data['cart-drawer']) {
          var newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var newDrawer = newDoc.querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
            oldDrawer.classList.remove('is-empty');
          }
        }

        if (data['cart-icon-bubble']) {
          var newDoc2 = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = newDoc2.body.firstElementChild;
          var oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          var trigger = document.querySelector('#cart-icon-bubble a, a[href$="/cart"]');
          if (trigger) trigger.click();
        }
      })
      .catch(function (err) {
        console.warn('[Mini-cart upsell] Could not refresh cart drawer, reloading.', err);
        window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart'
          : '/cart';
      });
  }

  function setState(btn, state) {
    btn.classList.remove('is-loading', 'is-added');
    if (state !== 'idle') btn.classList.add('is-' + state);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mcu-atc]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');

    if (!variantId) {
      window.location.href = btn.getAttribute('href');
      return;
    }

    if (btn.classList.contains('is-loading')) return;
    setState(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Add to cart failed');
          });
        }
        return res.json();
      })
      .then(function () {
        setState(btn, 'added');
        setTimeout(function () {
          setState(btn, 'idle');
          refreshDawnCart();
        }, 700);
      })
      .catch(function (err) {
        console.warn('[Mini-cart upsell]', err.message);
        setState(btn, 'idle');
        window.location.href = btn.getAttribute('href');
      });
  });
})();
